<script lang="ts">
	//UI
	import { InlineButton } from "@hitit/new_ui";
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	//Utils
	import { createEventDispatcher } from "svelte";
	//Types
	//Props
	export let status = "";
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	//Functions
	const deleteClickHandler = () => dispatch("DELETE");
	const editClickHandler = () => dispatch("EDIT");
	//Do
</script>

<div class="container" id="noticereader-control">
	<div class="status">
		<span
			class:obsolete={status === "OBSOLETE"}
			class:published={status === "PUBLISHED"}
			class="status-icon"
		/>
		{status}
	</div>
	<div class="controls">
		<InlineButton on:click={deleteClickHandler}>
			<img src={"/img/icons/deleteIcon.png"} class="delete" alt="delete" />
		</InlineButton>
		<InlineButton on:click={editClickHandler}>
			<img src={EditIcon} class="edit" alt="edit" />
		</InlineButton>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;

		.status {
			display: flex;
			align-items: center;
			gap: 10px;
			color: #46474b;
		}

		.status-icon {
			width: 15px;
			height: 15px;
			background-color: #bcbfc3;
			border-radius: 15px;

			&.obsolete {
				background-color: #ffce00;
			}
			&.published {
				background-color: #44e4ae;
			}
		}

		.controls {
			display: flex;
			gap: 20px;
			align-items: center;

			img.delete {
				width: 24px;
				height: 24px;
				object-fit: contain;
			}
			img.edit {
				width: 24px;
				height: 24.2px;
				object-fit: contain;
			}
		}
	}

	@include DesktopSize {
		.container {
			.status {
				gap: 7px;
				font-size: 1.25rem;
			}
			.status-icon {
				width: 20px;
				height: 20px;
				margin-top: 2px;
			}

			.controls {
				img.delete {
					width: 26px;
					height: 26px;
				}
			}
		}
	}
</style>
